"use client";

import Link from "next/link";
import { ComputeRow } from "../sidebar-v2/usage-card/usage-rows";
import { useUsageSummary } from "../sidebar-v2/usage-card/use-usage-summary";

/** Compute spend against its budget, kept in view in the app bar. Opens the usage page. */
export function UsageMeter() {
  const summary = useUsageSummary();
  if (summary === null || summary.compute === null) {
    return null;
  }

  return (
    <Link
      href={summary.href}
      aria-label="Usage"
      className="mr-2 hidden w-40 rounded-lg px-2.5 py-1.5 transition-colors hover:bg-grayA-3 focus-visible:outline-2 focus-visible:outline-(--focus-ring) lg:block"
    >
      <ComputeRow measured={summary.compute} />
    </Link>
  );
}
